import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {
  initiateEmailVerification, initiateOAuth, initiatePasswordRecovery, logInWithCredentials,
  signUpWithCredentials
} from '../../../ducks/auth';
import asSubmissionError, {asMappedSubmissionError} from '../../../utils/asSubmissionError';
import getPublicUrl from '../../../utils/getPublicUrl';

import Button from '../../../components/button/Button';
import SignInForm from '../../../components/auth/SignInForm';
// import OAuthForm from '../../../components/auth/OAuthForm';
import SignUpForm from '../../../components/auth/SignUpForm';
import EmailVerificationRequestForm from '../../../components/auth/EmailVerificationRequestForm';
import RecoverPasswordForm from '../../../components/auth/RecoverPasswordForm';
import {FormattedMessage} from 'react-intl';

export const STATE_SIGN_IN = 'signIn';
export const STATE_VERIFY_EMAIL = 'verify';
export const STATE_SIGN_UP = 'signUp';
export const STATE_SIGN_UP_SUCCESS = 'signUpSuccess';
export const STATE_RECOVERY = 'recovery';
export const STATE_RECOVERY_SUCCESS = 'recoverySuccess';

@connect()
export default class AuthFlow extends React.PureComponent {
  static propTypes = {
    initialState: PropTypes.string
  };

  static defaultProps = {
    initialState: STATE_SIGN_IN
  };

  constructor(props) {
    super(props);

    this.state = {
      flowState: props.initialState,
      email: ''
    };
  }

  toFlowState = (flowState, rest = {}) => this.setState({flowState, ...rest});

  logIn = ({login, password}) => this.props.dispatch(logInWithCredentials(login, password))
    .catch(asSubmissionError)
    .catch(err => {
      if (err.errors._error === 'Account has not been verified yet.') {
        this.toFlowState(STATE_VERIFY_EMAIL, {email: login});
      }

      throw err;
    });

  verify = ({email}) => this.props.dispatch(initiateEmailVerification(email))
    .then(() => this.toFlowState(STATE_SIGN_UP_SUCCESS))
    .catch(asSubmissionError);

  signUp = ({email, password, tosAccepted, newsletterSubscribed}) =>
    this.props.dispatch(signUpWithCredentials(email, password, tosAccepted, newsletterSubscribed))
      .catch(asMappedSubmissionError({'user.plainPassword': 'password'}))
      .then(() => this.props.dispatch(initiateEmailVerification(email))
        .then(
          () => this.toFlowState(STATE_SIGN_UP_SUCCESS),
          () => this.toFlowState(STATE_VERIFY_EMAIL, {email})
        )
      );

  recoverPassword = ({email}) => this.props.dispatch(initiatePasswordRecovery(email))
    .then(() => this.toFlowState(STATE_RECOVERY_SUCCESS))
    .catch(asSubmissionError);

  oAuth = ({provider}) => this.props.dispatch(initiateOAuth(provider, `${getPublicUrl()}/auth/oauth-claim`))
    .then(oAuthResponse => {
      const {token, url} = oAuthResponse.content;

      localStorage.setItem('oAuthToken', token);
      window.location = url;
    });

  render() {
    const {flowState} = this.state;

    switch (flowState) {
      case STATE_SIGN_IN:
        return (
          <React.Fragment>
            <div className="modal__column">
              <div className="modal__header">
                <FormattedMessage id="section.auth.login"/>
              </div>

              <SignInForm onSubmit={this.logIn}/>

              <button className="modal__forgot" onClick={() => this.toFlowState(STATE_RECOVERY)}>
                <FormattedMessage id="section.auth.forgot"/>
              </button>

              <Button full onClick={() => this.toFlowState(STATE_SIGN_UP)}>
                <FormattedMessage id="section.auth.create"/>
              </Button>
            </div>

            {/* TODO: temporarily hidden oAuth login buttons */}
            {/*<div className="modal__column  modal__column--social">*/}
            {/*  <OAuthForm onSubmit={this.oAuth}/>*/}
            {/*</div>*/}
          </React.Fragment>
        );

      case STATE_SIGN_UP:
        return (
          <div className="modal__column">
            <div className="modal__header">
              <FormattedMessage id="section.auth.sign-up.title"/>
            </div>
            <SignUpForm onSubmit={this.signUp}/>
            <button className="modal__forgot" onClick={() => this.toFlowState(STATE_SIGN_IN)}>
              <FormattedMessage id="section.auth.already-have"/>
            </button>
          </div>
        );

      case STATE_VERIFY_EMAIL:
        return (
          <div className="modal__column">
            <div className="modal__header">
              <FormattedMessage id="section.auth.verification.title"/>
            </div>
            <EmailVerificationRequestForm onSubmit={this.verify} initialValues={{email: this.state.email}}/>
          </div>
        );

      case STATE_SIGN_UP_SUCCESS:
        return (
          <div className="modal__column">
            <div className="modal__notice">
              <FormattedMessage id="section.auth.sign-up.success"/>
            </div>
          </div>
        );

      case STATE_RECOVERY:
        return (
          <div className="modal__column">
            <div className="modal__header">
              <FormattedMessage id="section.auth.password.recover"/>
            </div>
            <RecoverPasswordForm onSubmit={this.recoverPassword}/>
            <button className="modal__forgot" onClick={() => this.toFlowState(STATE_SIGN_IN)}>
              <FormattedMessage id="section.auth.back"/>
            </button>
          </div>
        );

      case STATE_RECOVERY_SUCCESS:
        return (
          <div className="modal__column">
            <div className="modal__notice">
              <FormattedMessage id="section.auth.password.recover-success"/>
            </div>
          </div>
        );
    }
  }
}



// WEBPACK FOOTER //
// ./containers/auth/modals/AuthFlow.js